import { createSelector } from 'reselect';
import { get } from 'lodash';

const selectProject = state => state.modals.Order.project;

export default createSelector(
  selectProject,
  (project) => get(project, 'estimates', [])
)